import React, { Component } from 'react';
import { Text, View, TouchableOpacity, Dimensions, SafeAreaView, Alert } from '../../src/web/react-native';
import Icon from '../../src/components/Icon';
import { connect } from 'react-redux';
import Service from './../../Service/service';
import InProgress from '../InProgress';
import TakeOver from './TakeOver';
import { createMaterialTopTabNavigator } from '../../src/navigation/topTabs';
import moment from 'moment';
import { LoadingOverlay } from '../../src/components';
import {
  GetShiftLogsActionAsync,
  GetTeamShiftLogsActionAsync,
} from './../../Action/ShiftLogAction';
import { GetPreferenceActionAsync } from './../../Action/PreferenceAction';
import { Route } from '../../src/app/Route';
import { DdLogs } from '../../src/logging/datadog';

export class MyPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentShift: '',
      shiftName: '',
      userName: '',
      path: '',
      assetName: '',
      currentShiftStart: '',
      isLoading: false,
      isShiftLogLoading: false,
      width: Dimensions.get('window').width,
    };
  }
  async componentDidMount() {
    DdLogs.info('MyPost.js componentdidmount:  ');
    const user = this.props.user;
    this.setState({
      userName: user.name,
    });
    this.focusMyPostListener = this.props.navigation.addListener('focus', () => {
      this.setState({});
    });
    this.focusMyPostInProgressListener = this.props.navigation.addListener('focus', () => {
      this.setState({});
    });

    Dimensions.addEventListener('change', () => {
      this.setState({
        width: Dimensions.get('window').width,
        height: Dimensions.get('window').height,
      });
    });
  }
  componentWillUnmount() {
    this.focusMyPostListener && this.focusMyPostListener();
    this.focusMyPostInProgressListener && this.focusMyPostInProgressListener();
  }
  fetchUserInfo = async () => {
    const user = this.props.user;
    let localPreference = await Service.getLocalPreferences();
    if (this.state.shiftName == '') {
      this.setState({
        isLoading: true,
        userName: user.name,
      });
      this.props
        .GetPreference(localPreference)
        .then((res) => {
          this.setState({
            isLoading: false,
          });
        })
        .catch((err) => DdLogs.error('Failed to get preference', err));
    }
  };
  fetchShiftLogs = async () => {
    let localPreference = await Service.getLocalPreferences();

    this.setState({
      isShiftLogLoading: true,
    });
    this.props
      .GetShiftLogs(localPreference)
      .then((res) => {
        this.setState({
          isShiftLogLoading: false,
        });
      })
      .catch((err) => {
        DdLogs.error('Failed to get shift logs', err);
        this.setState({
          isShiftLogLoading: false,
        });
      });
  };
  render() {
    const width = this.state.width;
    DdLogs.info('My post.js render: ' + width);
    const Tab = createMaterialTopTabNavigator();
    // console.log('render MyPost.js: '+JSON.stringify(this.props.preference))
    return (
      <View
        style={{
          flex: 1,
          width: '100%',
          backgroundColor: '#F4F8F9',
          alignItems: 'center',
        }}>
        {<LoadingOverlay visible={this.state.isLoading || this.state.isShiftLogLoading} />}

        <View
          style={{
            height: 60,
            alignItems: 'center',
            width: '94%',
            backgroundColor: '#fff',
            marginTop: 8,
          }}>
          {/*************     Header      *************/}
          <View
            style={{
              flexDirection: 'row',
              width: 0.9 * width,
              marginVertical: 5,
              justifyContent: 'space-between',
            }}>
            <Text style={{ fontSize: 20, color: '#5A5A5A' }}>{this.state.userName}</Text>
            <Text style={{ fontSize: 20, color: '#5A5A5A' }}>
              {this.props.preference.shiftName}
            </Text>
          </View>
          <View style={{ width: 0.9 * width }}>
            <Text style={{ color: '#5A5A5A' }}>
              {moment(this.props.preference.currentShiftStart)
                .format('MMM DD, h:mm a')
                .concat(' - ')
                .concat(moment(this.props.preference.currentShiftEnd).format('MMM DD, h:mm a'))}
            </Text>
          </View>
        </View>
        <View
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 35,
            width: 0.94 * width,
            marginTop: 3,
            backgroundColor: '#fff',
            paddingHorizontal: 8,
            flexDirection: 'row',
          }}>
          {/*************     Edit Preferences Row      *************/}
          <View
            style={{
              flexDirection: 'row',
              flex: 1,
              flexWrap: 'wrap',
              flexShrink: 1,
            }}>
            <Text style={{ color: '#5A5A5A' }}>
              {this.props.preference.path?.split('\\').join(' | ')}
            </Text>
          </View>
          <View style={{ alignItems: 'center' }}>
            <TouchableOpacity
              onPress={() => {
                this.props.navigation.navigate(Route.preferenceNavScreen, {
                  canNavigateBack: true,
                });
                // console.log(this.props.preference)
              }}
              style={{ flexDirection: 'row', alignItems: 'center' }}>
              <Text>
                <Icon name="pencil" size={15} color="#00A3E0"></Icon>
              </Text>
              <Text
                style={{
                  color: '#00A3E0',
                  fontWeight: '500',
                  fontSize: 15,
                  marginLeft: 4,
                }}>
                Edit
              </Text>
            </TouchableOpacity>
          </View>
        </View>

        {/*************     Segment Control      *************/}
        <SafeAreaView
          style={{
            flex: 1,
            width: 0.94 * width,
            marginTop: 5,
            backgroundColor: '#fff',
          }}>
          <Tab.Navigator
            initialRouteName={Route.inProgress}
            tabBar={(props) => (
              <MyPostTabStatusBar props={props} shiftLogs={this.props.shiftLogs} />
            )}>
            <Tab.Screen
              name={Route.inProgress}
              component={InProgress}
              initialParams={{ isTeamLog: false }}
              options={{ title: 'In Progress' }}
            />
            <Tab.Screen
              name={Route.takenOver}
              component={TakeOver}
              initialParams={{ isTeamLog: false }}
              options={{ title: 'Taken Over' }}
            />
          </Tab.Navigator>
        </SafeAreaView>
      </View>
    );
  }
}

function MyPostTabStatusBar({ props, shiftLogs }) {
  let { state, descriptors, navigation, position, route } = { ...props };
  const width = Dimensions.get('window').width;

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      {state.routes.map((route, index) => {
        const { options } = descriptors[route.key];
        const label =
          options.tabBarLabel !== undefined
            ? options.tabBarLabel
            : options.title !== undefined
            ? options.title
            : route.name;
        const isFocused = state.index === index;
        const onPress = () => {
          const event = navigation.emit({
            type: 'tabPress',
            target: route.key,
          });

          if (!isFocused && !event.defaultPrevented) {
            navigation.navigate(route.name, {
              isTeamLog: false,
            });
          }
        };

        return (
          <TouchableOpacity
            accessibilityLabel={options.tabBarAccessibilityLabel}
            testID={options.tabBarTestID}
            onPress={onPress}
            style={{ flex: 1, marginVertical: 5 }}
            key={route.key}>
            <View
              style={[{ height: 45 }, getTextStyle(width, index, state.routes.length, isFocused)]}>
              <Text style={isFocused ? { color: '#fff' } : { color: '#000' }}>{label}</Text>
              <Text style={isFocused ? { color: '#fff' } : { color: '#000' }}>
                {route.name == 'TakenOver'
                  ? shiftLogs.filter((val) => val.status == 'TakenOver').length
                  : shiftLogs.filter((val) => val.status != 'TakenOver').length}
              </Text>
            </View>
          </TouchableOpacity>
        );
      })}
    </View>
  );
}
function getTextStyle(width, index, length, isFocused) {
  let selected = {};
  if (isFocused) {
    selected = { backgroundColor: '#00A3E0' };
  }

  if (index == 0) {
    return {
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#EEF3F4',
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10,
      marginLeft: 5,
      ...selected,
    };
  } else {
    return {
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#EEF3F4',
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10,
      marginRight: 5,
      ...selected,
    };
  }
}

const mapStateToProps = (state) => ({
  shiftLogs: state.shiftLogs.shiftLogs,
  preference: state.preference.preferences,
  user: state.user.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    GetShiftLogs: (preference, params) => {
      const payload = {
        siteCode: preference.site.siteCode,
        assetName: Service.getShiftLogAssetName(preference),
      };
      if (params && !params.isMyPostFocused) {
        return dispatch(GetTeamShiftLogsActionAsync(payload));
      } else {
        return dispatch(GetShiftLogsActionAsync(payload));
      }
    },
    GetPreference: (preference) => {
      return dispatch(GetPreferenceActionAsync(preference.site.siteCode));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyPost);